 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","aml-policy":"aml-policy","auction":"auction","authorized":"authorized","liquidity":"liquidity","policy":"policy","rewards":"rewards","risks":"risks","stakeMetamask":"stakeMetamask","stats":"stats","terms":"terms","view":"view","withdraw":"withdraw"}[chunkId]||chunkId) + "." + {"about":"4301361d","aml-policy":"6a211d96","auction":"537da2f8","authorized":"ccbaa65a","chunk-07c95b10":"95225878","chunk-07c9c38e":"7fe6af3c","chunk-07c9cb72":"57cb7b6b","chunk-07ca38c8":"29051697","chunk-07ccdb2a":"4ead5463","chunk-07f1cc56":"49b39016","chunk-07f29a96":"a912763c","chunk-07f2b18c":"75d20309","chunk-07f34af8":"15877929","chunk-07f3a5e8":"05847a5d","chunk-07f5e290":"262aabc1","chunk-07f6059c":"0e52c8c2","chunk-07f72dbe":"535d6ca0","chunk-07f9031e":"647e27f8","chunk-07f91110":"acb73522","chunk-07f9a910":"91b98b5b","chunk-07fa7230":"9f3dde63","chunk-07fa888e":"b39d5647","chunk-152bc6bc":"bf4cd019","chunk-1c49310a":"e7b4e606","chunk-22c978de":"a7294c65","chunk-2d0ae62f":"1dcfd278","chunk-2d0af6bd":"4a7334d9","chunk-2d0afa20":"c7143949","chunk-2d0b61a8":"d5cb4d9a","chunk-2d0b68af":"f04a0fa3","chunk-2d0c4615":"1fc5a6df","chunk-2d0c7ed0":"65be21f0","chunk-2d0d7133":"a6b3b670","chunk-2d0de971":"b29d11d5","chunk-2d0e87e8":"2e24ea76","chunk-2d21d8a2":"335bd65d","chunk-2d226cad":"d506b922","chunk-2d229083":"e57f01d2","chunk-42025617":"ea1c9b78","chunk-bef00f0e":"317cfa2e","chunk-b64b5c8a":"cfc50aea","chunk-50e4c5f0":"ab362b27","chunk-d12af7fe":"fd88610d","liquidity":"77ffcdd1","policy":"69a592df","rewards":"a1c7ae33","risks":"5f569cfb","stakeMetamask":"80d90861","stats":"ae69660a","terms":"ca8c0f13","view":"03ac4f06","withdraw":"21ed7d36","chunk-599cda81":"3cd14e20","chunk-1710ec7b":"bdeab6f9","chunk-1ecdbfc6":"3d40e68d","chunk-0b57bfae":"aadd6020","chunk-93d74738":"10b0ea3e","chunk-2d0d6394":"8dc49449","chunk-a9178d68":"4e40811f","chunk-0079d2bb":"e028f2af","chunk-6bfa2d17":"54b8c5cf","chunk-040be9a3":"f8a86ebe","chunk-2d21e3c2":"b515134f","chunk-069843ae":"bdbd2e2d","chunk-0f12601c":"0846d1cd","chunk-10e7db40":"1e76ab53","chunk-4b39c7b6":"9e3e80ef","chunk-a3cf612e":"a26bafde","chunk-318fbc40":"211dc460","chunk-2d0f1539":"3a838cd4","chunk-2d0b93f9":"7093c530","chunk-2c6e76a8":"d83cbb55","chunk-9055abee":"d5c7f9e5","chunk-41818524":"9b035404","chunk-2d0d9f40":"2a33e5b4","chunk-1aaf8c6b":"918e7d29","chunk-da25c758":"a443c025","chunk-3043873a":"e8737184"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about":1,"aml-policy":1,"auction":1,"authorized":1,"liquidity":1,"policy":1,"rewards":1,"risks":1,"stakeMetamask":1,"stats":1,"terms":1,"view":1,"withdraw":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","aml-policy":"aml-policy","auction":"auction","authorized":"authorized","liquidity":"liquidity","policy":"policy","rewards":"rewards","risks":"risks","stakeMetamask":"stakeMetamask","stats":"stats","terms":"terms","view":"view","withdraw":"withdraw"}[chunkId]||chunkId) + "." + {"about":"34f69766","aml-policy":"9e2a3e31","auction":"bcc0730c","authorized":"74b2a976","chunk-07c95b10":"31d6cfe0","chunk-07c9c38e":"31d6cfe0","chunk-07c9cb72":"31d6cfe0","chunk-07ca38c8":"31d6cfe0","chunk-07ccdb2a":"31d6cfe0","chunk-07f1cc56":"31d6cfe0","chunk-07f29a96":"31d6cfe0","chunk-07f2b18c":"31d6cfe0","chunk-07f34af8":"31d6cfe0","chunk-07f3a5e8":"31d6cfe0","chunk-07f5e290":"31d6cfe0","chunk-07f6059c":"31d6cfe0","chunk-07f72dbe":"31d6cfe0","chunk-07f9031e":"31d6cfe0","chunk-07f91110":"31d6cfe0","chunk-07f9a910":"31d6cfe0","chunk-07fa7230":"31d6cfe0","chunk-07fa888e":"31d6cfe0","chunk-152bc6bc":"31d6cfe0","chunk-1c49310a":"31d6cfe0","chunk-22c978de":"31d6cfe0","chunk-2d0ae62f":"31d6cfe0","chunk-2d0af6bd":"31d6cfe0","chunk-2d0afa20":"31d6cfe0","chunk-2d0b61a8":"31d6cfe0","chunk-2d0b68af":"31d6cfe0","chunk-2d0c4615":"31d6cfe0","chunk-2d0c7ed0":"31d6cfe0","chunk-2d0d7133":"31d6cfe0","chunk-2d0de971":"31d6cfe0","chunk-2d0e87e8":"31d6cfe0","chunk-2d21d8a2":"31d6cfe0","chunk-2d226cad":"31d6cfe0","chunk-2d229083":"31d6cfe0","chunk-42025617":"31d6cfe0","chunk-bef00f0e":"31d6cfe0","chunk-b64b5c8a":"31d6cfe0","chunk-50e4c5f0":"31d6cfe0","chunk-d12af7fe":"31d6cfe0","liquidity":"0565674c","policy":"9b1a1305","rewards":"b9e66bbd","risks":"0e433876","stakeMetamask":"6430995a","stats":"6bb989d3","terms":"14de62b3","view":"42e782b5","withdraw":"68041aed","chunk-599cda81":"31d6cfe0","chunk-1710ec7b":"31d6cfe0","chunk-1ecdbfc6":"31d6cfe0","chunk-0b57bfae":"31d6cfe0","chunk-93d74738":"31d6cfe0","chunk-2d0d6394":"31d6cfe0","chunk-a9178d68":"31d6cfe0","chunk-0079d2bb":"31d6cfe0","chunk-6bfa2d17":"31d6cfe0","chunk-040be9a3":"31d6cfe0","chunk-2d21e3c2":"31d6cfe0","chunk-069843ae":"31d6cfe0","chunk-0f12601c":"31d6cfe0","chunk-10e7db40":"31d6cfe0","chunk-4b39c7b6":"31d6cfe0","chunk-a3cf612e":"31d6cfe0","chunk-318fbc40":"31d6cfe0","chunk-2d0f1539":"31d6cfe0","chunk-2d0b93f9":"31d6cfe0","chunk-2c6e76a8":"31d6cfe0","chunk-9055abee":"31d6cfe0","chunk-41818524":"31d6cfe0","chunk-2d0d9f40":"31d6cfe0","chunk-1aaf8c6b":"31d6cfe0","chunk-da25c758":"31d6cfe0","chunk-3043873a":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
